import type { Period } from './api';

export type Slot = { weekday: number | null; periodId: string | null };

const toMinutes = (time: string) => {
  const [hours = '0', minutes = '0'] = time.split(':');
  return Number(hours) * 60 + Number(minutes);
};

/** Today's weekday (1 = Monday ... 5 = Friday, null in the weekend) and the period running at this moment. */
export function slotAt(periods: Period[], now: Date): Slot {
  const day = now.getDay();
  const weekday = day >= 1 && day <= 5 ? day : null;
  const minutes = now.getHours() * 60 + now.getMinutes();
  const running = periods.find((period) => toMinutes(period.startTime) <= minutes && minutes < toMinutes(period.endTime));
  return { weekday, periodId: running?.id ?? null };
}
